import { gql } from "@apollo/client";

export const GET_POIS = gql`
  query GetPois($buildingId: uuid) {
    POI(
      where: {
        BuildingId: { _eq: $buildingId }
        _and: { IsActive: { _eq: true } }
      }
    ) {
      Description
      Id
      IsActive
      Lat
      Long
      floorId
      created_at
      macAddress
      updated_at
      virtual
      PoiType {
        description
        title
        id
        organizationId
      }
    }
  }
`;

export const GET_POIS_BY_TYPE = gql`
  query GetPoisByType($buildingId: uuid, $poiTypes: [uuid!]) {
    POI(
      where: {
        BuildingId: { _eq: $buildingId }
        _and: {
          IsActive: { _eq: true }
          _and: { poiTypeId: { _in: $poiTypes } }
        }
      }
    ) {
      Description
      Id
      IsActive
      Lat
      Long
      floorId
      created_at
      macAddress
      updated_at
      virtual
      PoiType {
        description
        title
        id
        organizationId
      }
    }
  }
`;

export const GET_POI_TYPES = gql`
  query GetPoiTypes {
    PoiType(order_by: { created_at: asc }) {
      customFields
      description
      id
      organizationId
      title
      updated_at
      created_at
    }
  }
`;
